import React, { useState, useEffect } from "react";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { Col, Row, Table, Image, Modal, Button, Form } from "react-bootstrap";
import {
  FormControl,
  Select,
  IconButton,
  InputLabel,
  MenuItem,
} from "@material-ui/core";
import { useFormik } from "formik";
import Alert from "react-s-alert";
import * as yup from "yup";
import { ToggleButtonWithYesNo } from "../../../vendorOnboradingComponents/allScreens/NewSubscriptionScreen/AllButton/ToggleButtonReuse";
import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { update_new_subscription_for_vendor } from "../../../../store/actions/authAction";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import isEmpty from "../../../../store/validation/is-Empty";

function AddTable(props) {
  const [showCreateTable, setshowCreateTable] = useState(false);
  const [editTable, setEditTable] = useState(false);
  const [allDashboardTableData, setAllDashboardTableData] = useState([]);
  const [filteredTableDataDashboard, setFilteredTableDataDashboard] = useState(
    []
  );
  const [tableUniqueId, setTableUniqueId] = useState("");

  const [activeFloorTableDashboard, setActiveFloorTableDashboard] = useState(
    ""
  );
  const [activeAreaTableDashboard, setActiveAreaTableDashboard] = useState("");

  const handleCloseCreateTable = () => setshowCreateTable(!showCreateTable);
  const [uniqueFloorData, setUniqueFloorData] = useState([]);
  const [activeSectionData, setActiveSectionData] = useState([]);

  const showAlert = (msg) => {
    Alert.success(`<h4>${msg}</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  const onChangeFloorArea = (e) => {
    formikTable.setFieldValue("area", e.target.value);
  };

  const formikTable = useFormik({
    initialValues: {
      floor_number: "",
      area: "",
      table_number: "",
      shape: "Circle",
      pax_value: "",
      temporay: false,
      active: true,
      location: "",
      status: "AVAILABLE",
      number: "",
    },
    validationSchema: yup.object({
      floor_number: yup.string().required("Please select floor number "),
      area: yup.string().required("Please select area/section "),
      table_number: yup.string().required("Please enter table number"),
      pax_value: yup.string().required("Please select total capacity"),
      location: yup.string().required("Please select table location "),
      number: yup.string().required("Please enter numer of tables "),
    }),

    onSubmit: (values) => {
      let table = [];
      let existingTableData = allDashboardTableData;
      let newAn = existingTableData.filter(ele => ele.table_number.includes(`${values.table_number}-`));
      let inc = 0;
      if (!isEmpty(newAn)) {
        let lastNum = newAn[newAn.length - 1];
        lastNum = lastNum.table_number.split('-');
        inc = parseInt(lastNum[lastNum.length - 1]);
      }
      for (let i = 0; i < values.number; i++) {
        let increment_number = inc + i + 1;
        let incrementTableNumber = values.table_number + "-" + increment_number;
        let generateUniqueId = allDashboardTableData.length + increment_number;
        table.push({
          ...values,
          table_number: incrementTableNumber,
          uniqueId: generateUniqueId,
        });
      }
      let formData = [...existingTableData, ...table];
      //   console.log(formData);
      setAllDashboardTableData(formData);
      setFilteredTableDataDashboard(formData);

      const formData1 = props.allSubscriptionData;
      formData1.casual_dining_status.seating.table_management.table_setup.table = formData;

      const token = props.auth.user.accessToken;
      const subscriptionId = props.subscription._id;

      props.update_new_subscription_for_vendor(
        subscriptionId,
        formData1,
        token,
        onSuccess
      );
    },
  });
  const onSuccess = (e) => {
    formikTable.resetForm();
    handleCloseCreateTable();
    Alert.success(`<h4>Table setup Successfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  const [tableLocation, setTableLocation] = useState([]);
  const tableShape = [
    { name: "Circle", totalPax: [1, 2, 3, 4] },
    { name: "Square", totalPax: [1, 2, 3, 4] },
    { name: "Rectangle", totalPax: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] },
  ];

  const onCLickAddNewTable = () => {
    formikTable.handleSubmit();
  };

  const onChangeSelectTable = (name) => {
    formikTable.setFieldValue("location", name);
  };
  const onChangeFloorNumber = (e) => {
    let floorNo = e.target.value;
    //let activeData=[]
    for (let i = 0; i < uniqueFloorData.length; i++) {
      if (uniqueFloorData[i].name === floorNo) {
        setActiveSectionData(uniqueFloorData[i].items);
        break;
      }
    }
    formikTable.setFieldValue("floor_number", floorNo);
    formikTable.setFieldValue("area", "");
  };
  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };
  const [activeTableShape, setActiveTableShape] = useState([1, 2, 3, 4]);
  const onChangeTableShape = (e) => {
    let tableShpe = e.target.value;
    formikTable.setFieldValue("shape", tableShpe);
    formikTable.setFieldValue("pax_value", "");
    for (let i = 0; i < tableShape.length; i++) {
      if (tableShpe === tableShape[i].name) {
        setActiveTableShape(tableShape[i].totalPax);
        break;
      }
    }
  };

  const onChangeTableTemporary = () => {
    formikTable.setFieldValue("temporay", !formikTable.values.temporay);
  };

  const onChangeTableActiveInActive = () => {
    if (!formikTable.values.active === false) {
      formikTable.setFieldValue("status", "UNAVAILABLE");
      formikTable.setFieldValue("active", !formikTable.values.active);
    } else {
      formikTable.setFieldValue("active", !formikTable.values.active);
      formikTable.setFieldValue("status", "AVAILABLE");
    }
  };

  useEffect(() => {
    let data = props.allSubscriptionData;

    if (
      data &&
      data.casual_dining_status &&
      data.casual_dining_status.seating &&
      data.casual_dining_status.seating.table_management.table_setup
    ) {
      let setDropDownDataForTable =
        data.casual_dining_status.seating.table_management.table_setup.floors;
      // set unique id to each recond locally

      // for table starts
      let asiignIdToEachRecord = []; // help us to delete or edit record

      let apiTableData =
        data.casual_dining_status.seating.table_management.table_setup.table;

      for (let i = 0; i < apiTableData.length; i++) {
        let incrementId = i + 1;
        let data = apiTableData[i];
        data.uniqueId = incrementId;
        asiignIdToEachRecord.push(data);
      }

      setAllDashboardTableData(asiignIdToEachRecord); // this is our main reference
      setFilteredTableDataDashboard(asiignIdToEachRecord);

      //// for table ends

      //
      let uniqueFloors = [];
      for (let i = 0; i < setDropDownDataForTable.length; i++) {
        if (!uniqueFloors.includes(setDropDownDataForTable[i].floor_number)) {
          uniqueFloors.push(setDropDownDataForTable[i].floor_number);
        }
      }

      let structuredData = [];
      for (let i = 0; i < uniqueFloors.length; i++) {
        structuredData.push({ name: uniqueFloors[i], items: [] });
      }
      let finalStructuredData = structuredData;
      for (let i = 0; i < setDropDownDataForTable.length; i++) {
        for (let j = 0; j < structuredData.length; j++) {
          if (
            structuredData[j].name === setDropDownDataForTable[i].floor_number
          ) {
            finalStructuredData[j].items.push(setDropDownDataForTable[i].area);
          }
        }
      }

      setUniqueFloorData(finalStructuredData);

      let selectedSeating =
        data.casual_dining_status.seating.general_seating.seating_areas;
      let seatingSelected = [];

      for (let i = 0; i < props.seating_area.length; i++) {
        if (selectedSeating.includes(props.seating_area[i]._id)) {
          seatingSelected.push(props.seating_area[i]);
        }
      }
      setTableLocation(seatingSelected);
    }
  }, [props.allSubscriptionData, props.seating_area]);

  return (
    <React.Fragment>
      <div align="right">
        <div
          className="btn btn-outline-danger"
          style={{ borderRadius: "4px" }}
          onClick={handleCloseCreateTable}
        >
          + Add Table
        </div>
      </div>
      <Modal show={showCreateTable} onHide={handleCloseCreateTable} centered>
        <Modal.Header className="px-4 border-0" closeButton>
          <div>
            <Modal.Title className="f20-700 pb-2">Create a Table</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body className="px-4 new-subscription-onboarding-component">
          <Form>
            <Row>
              <Col md={6}>
                <FormControl variant="outlined" className={"w-100 mb-3"}>
                  <InputLabel htmlFor="outlined-section">
                    Floor Number /Name
                  </InputLabel>
                  <Select
                    value={formikTable.values.floor_number}
                    onChange={onChangeFloorNumber}
                    label="Section Number /Name"
                    inputProps={{
                      name: "floor",
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    {uniqueFloorData.map((item, index) => (
                      <MenuItem key={index} value={item.name}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                  {formikTable.errors.floor_number &&
                    formikTable.touched.floor_number ? (
                    <div className="pho_14_regular text-danger">
                      {formikTable.errors.floor_number}
                    </div>
                  ) : null}
                </FormControl>
              </Col>
              <Col md={6}>
                <FormControl variant="outlined" className={"w-100 mb-3"}>
                  <InputLabel htmlFor="outlined-section">
                    Section Number /Name
                  </InputLabel>
                  <Select
                    value={formikTable.values.area}
                    onChange={onChangeFloorArea}
                    label="Section Number /Name"
                    inputProps={{
                      name: "section",
                      id: "outlined-section",
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    {activeSectionData.map((item, index) => (
                      <MenuItem key={index} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                  {formikTable.errors.area && formikTable.touched.area ? (
                    <div className="pho_14_regular text-danger">
                      {formikTable.errors.area}
                    </div>
                  ) : null}
                </FormControl>
              </Col>
              <Col md={6}>
                <NewInputText
                  labelText="Table Number /Name"
                  extraClass={`mb-1 w-100 ${formikTable.errors.table_number &&
                    formikTable.touched.table_number
                    ? "enError"
                    : ""
                    }`}
                  inputType="text"
                  name="table_number"
                  onChange={formikTable.handleChange}
                  value={formikTable.values.table_number}
                  onFocusOut={formikTable.handleBlur}
                // isInvalid={
                //   formik.errors.bankName && formik.touched.bankName
                // }
                />
                {formikTable.errors.table_number &&
                  formikTable.touched.table_number ? (
                  <div className="pho_14_regular text-danger mb-2">
                    {formikTable.errors.table_number}
                  </div>
                ) : (
                  <div className="mb-2"></div>
                )}
              </Col>
              {/* <Col md={6}>
                <NewInputText
                  labelText="Table Capacity"
                  extraClass="mb-3 w-100"
                />
                <span className="f14-400 opacity5 enPositionRightTop">pax</span>
              </Col> */}
              <Col md={6}>
                <FormControl variant="outlined" className={"w-100 mb-3"}>
                  <InputLabel htmlFor="outlined-tableShape">
                    Table Shape
                  </InputLabel>
                  <Select
                    value={formikTable.values.shape}
                    //onChange={selecthandleChange}
                    onChange={onChangeTableShape}
                    name
                    label="Table Shape"
                    inputProps={{
                      name: "shape",
                      id: "outlined-tableShape",
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    <MenuItem value={"Circle"}>Circle &#9675;</MenuItem>
                    <MenuItem value={"Rectangle"}>Rectangle &#9645;</MenuItem>
                    <MenuItem value={"Square"}>Square &#9744;</MenuItem>
                  </Select>
                </FormControl>
              </Col>
              <Col md={6} className="mb-3">
                <FormControl variant="outlined" className={"w-100 mb-0"}>
                  <InputLabel htmlFor="outlined-tableCapacity">
                    Table Capacity
                  </InputLabel>
                  <Select
                    //value={state.tableCapacity}
                    value={formikTable.values.pax_value}
                    //onChange={selecthandleChange}
                    onChange={formikTable.handleChange}
                    label="Table Capacity"
                    inputProps={{
                      name: "pax_value",
                      id: "outlined-tableCapacity",
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    {activeTableShape.map((pax, index) => (
                      <MenuItem key={index} value={pax}>
                        {pax}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <div className="f10-400 opacity5">Total PAX</div>
                {formikTable.errors.pax_value &&
                  formikTable.touched.pax_value ? (
                  <div className="pho_14_regular text-danger">
                    {formikTable.errors.pax_value}
                  </div>
                ) : null}
              </Col>

              <Col md={6}>
                <div className="d-flex">
                  <div className="custom">
                    <div className="f10-400 pb-2 opacity5">Temporary Table</div>
                    <ToggleButtonWithYesNo
                      checkedBox={formikTable.values.temporay}
                      onChange={() => onChangeTableTemporary()}
                      className={"mx-1"}
                    />
                  </div>
                  <div className="pl-3 custom">
                    <div className="f10-400 pb-2 opacity5">
                      Active/ Inactive
                    </div>
                    <ToggleButtonWithYesNo
                      checkedBox={formikTable.values.active}
                      onChange={() => onChangeTableActiveInActive()}
                      className={"mx-1"}
                    />
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <div className="f12-400">Select Table Location</div>
                <div className="f10-400 opacity5 pb-3">
                  (Locations are based on the seating areas you have selected in
                  seating subscription)
                </div>
              </Col>
              {tableLocation.map((item, index) => (
                <Col md={4} key={index}>
                  <div className="enCheckWithText w-100">
                    <input
                      type="radio"
                      name="SeatingPreference"
                      checked={formikTable.values.location === item.title}
                      onChange={() => onChangeSelectTable(item.title)}
                    />
                    <label
                      className="w-100 d-flex align-items-center p-2"
                      style={{ fontSize: 11 }}
                    >
                      <Image
                        src={item.icon}
                        alt={item.title}
                        title={item.title}
                        className="mr-2"
                        style={{ width: "20%" }}
                      />
                      {item.title}
                    </label>
                  </div>
                </Col>
              ))}
            </Row>
            {formikTable.errors.location && formikTable.touched.location ? (
              <div className="pho_14_regular text-danger">
                {formikTable.errors.location}
              </div>
            ) : null}
            <Row className="align-items-center py-3">
              <Col md={6}>
                <div className="f12-400">Table Status</div>
              </Col>
              <Col md={6}>
                <FormControl variant="outlined" className={"w-100"}>
                  <Select
                    //value={state.tableStatus}
                    value={formikTable.values.status}
                    disabled={!formikTable.values.active}
                    //onChange={selecthandleChange}
                    onChange={formikTable.handleChange}
                    inputProps={{
                      name: "status",
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    <MenuItem value={"AVAILABLE"}>Available</MenuItem>
                    <MenuItem value={"UNAVAILABLE"}>Unavailable</MenuItem>
                    <MenuItem value={"OCCUPIED"}>Occupied</MenuItem>
                    <MenuItem value={"DIRTY"}>Dirty</MenuItem>
                    <MenuItem value={"ON_HOLD"}>On Hold</MenuItem>
                  </Select>
                </FormControl>
              </Col>
            </Row>
            {!editTable ? (
              <Row className="align-items-center py-3">
                <Col md={6}>
                  <div className="f12-400">How many Tables to Create?</div>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col>
                      <NewInputText
                        extraClass={`m-1 w-100 ${formikTable.errors.number &&
                          formikTable.touched.number
                          ? "enError"
                          : ""
                          }`}
                        inputType="number"
                        onInput={maxLengthCheck}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        maxLength={2}
                        name="number"
                        onChange={formikTable.handleChange}
                        value={formikTable.values.number}
                        onFocusOut={formikTable.handleBlur}
                      // isInvalid={
                      //   formik.errors.bankName && formik.touched.bankName
                      // }
                      />
                      {formikTable.errors.number &&
                        formikTable.touched.number ? (
                        <div className="pho_14_regular text-danger">
                          {formikTable.errors.number}
                        </div>
                      ) : null}
                    </Col>
                  </Row>
                </Col>
              </Row>
            ) : (
              <> </>
            )}
            <div className="d-flex justify-content-center align-items-center py-4">
              <Button
                variant="outline-secondary"
                className="btn150px btn-lg mr-4 px-5"
                onClick={handleCloseCreateTable}
              >
                Cancel
              </Button>
              <Button
                variant="danger"
                type="button"
                onClick={() => onCLickAddNewTable()}
                className="btn150px btn-lg px-5"
              >
                Submit
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}

AddTable.propTypes = {
  auth: PropTypes.object.isRequired,
  update_new_subscription_for_vendor: PropTypes.func.isRequired,
  subscription: PropTypes.object.isRequired,
  // subscriptionData: PropTypes.object.isRequired,
  // allSubscriptionsData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  seating_area: state.category.seating_area,
  allSubscriptionData:
    state.onboarding && state.onboarding.onboard_subscription_details,
  subscription:
    state.onboarding && state.onboarding.onboard_subscription_details,
  subscriptionData:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details.casual_dining_status &&
    state.onboarding.onboard_subscription_details.casual_dining_status
      .ordering &&
    state.onboarding.onboard_subscription_details.casual_dining_status.ordering
      .home_delivery,
});

export default connect(mapStateToProps, {
  update_new_subscription_for_vendor,
})(withRouter(AddTable));

// export default AddTable;
